<template>
  <div class="warnList">
    <div class="warnBox" v-for="(item,index) of WarningProp" :key="index" @click="WarnInfo(item)">
      <div class="warnBoxTop">
        <div class="warnBoxTopTitle">
          {{ item.Title }}
          <div class="warnBoxTopTime">
            {{ item.CreateTime }}
          </div>
        </div>
      </div>
      <div class="warnBoxTitle">
        <div class="warnBoxTitleRow" v-if="item.TitleName">
          {{ item.TitleName}}
        </div>
        <div class="warnBoxTitleRow" v-html="$options.filters.filters2(item.StringMessage)" v-if="item.StringMessage">
          <!-- {{ item.text2}} -->
          <!-- 还有<span style="color: #E71D43">5</span>天，该证件将要过期，请处理  v-html="s" -->
        </div>
        <div class="warnBoxTitleRow" v-if="item.TitleName2">
          {{ item.TitleName2}}
        </div>
        <div class="manage" @click.stop="manage(item.ViewUrl)">去查看 <img src="@/assets/channel/login/info-red.png" alt=""></div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    WarningProp: {
      type: Array
    }
  },
  data() {
    return {
    }
  },
  filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    // 查看预警详情
    WarnInfo(item) {
      this.$emit("WarnInfo", item)
    },
    manage(ViewUrl) {
      this.$router.push({
        path: ViewUrl
      })
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>

.warnBox:hover {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.048);
  transition: all 0.4s ease-in;
  -webkit-transition: all 0.4s ease-in;
  transform: translateY(-5px);
  cursor: pointer;
}
.warnList {
  height: 100%;
  position: relative;
  // top: 10px;
  transform: translateY(5px);
  transition: all 0.4s ease-in;
  -webkit-transition: all 0.4s ease-in;

  .warnBox:nth-child(3n-2) {
    margin-left: 0;
  }
  .warnBox {
    width: 382px;
    min-height: 140px;
    border: 1px solid #e6e8eb;
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.07999999821186066);
    border-radius: 4px;
    background-color: #fff;
    overflow-y: auto;
    margin-top: 26px;
    display: inline-block;
    margin-left: 24px;
    margin-bottom: -6px;
    // padding-bottom: 10px;
    overflow: hidden;
    position: relative;
    transition: all 0.4s ease-in;

    .warnBoxTop {
      width: 100%;
      height: 32px;
      border-bottom: 1px solid #ebedf0;
      background-color: #fff1f4;
      position: relative;

      .warnBoxTopTitle {
        color: #16181a;
        font-weight: bold;
        font-size: 14px;
        margin-left: 39px;
        line-height: 32px;
      }
      .warnBoxTopTitle::before {
        content: "";
        position: absolute;
        left: 15px;
        top: 12px;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 8.08px solid #e71d43;
        border-right: 0.2px solid transparent;
        filter: drop-shadow(4px 0px 0px #f7bbc6);
      }
      .warnBoxTopTime {
        color: #9ca5b8;
        font-weight: normal;
        font-size: 12px;
        line-height: 32px;
        float: right;
        margin-right: 16px;
      }
    }
    .warnBoxTitle {
      width: 95%;
      min-height: 88px;
      // border-left: 1px solid #e6e8eb;
      float: right;
      margin-top: 4px;
      position: relative;
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      
      .warnBoxTitleRow {
        width: 95%;
        height: 20px;
        // float: right;
        margin-left: 18px;
        margin-top: 10px;
        // border: 1px solid darkcyan;
        color: #16181a;
        font-size: 14px;
      }
      .warnBoxTitleRow::before {
        content: "";
        position: absolute;
        width: 5px;
        height: 5px;
        border: 2px solid #fff;
        border-radius: 50%;
        background-color: #e71d43;
        transform: translate(-255%, 60%);
      }
    }
  }
}
.manage {
  // border: 1px solid red;
  position: absolute;
  width: 44px;
  height: 18px;
  font-size: 12px;
  font-weight: normal;
  color: #e71d43;
  bottom:  0px;
  left: 300px;
  white-space: nowrap;

  img {
    vertical-align: middle;
  }
}
</style>